export enum CallingRuleBasis {
  STATUTE_TEXT = "STATUTE_TEXT",
  LEGAL_SUMMARY = "LEGAL_SUMMARY",
  NEEDS_REVIEW = "NEEDS_REVIEW",
}
